<template>
    <form-row title="Scheduled Closing Date" section_id="scheduled-closing">
        <div class="-mt-4">
            <input-date
                label="Date"
                name="scheduled_closing_date"
                v-model="scheduled_closing_date"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        read_only: { default: false },
    },

    computed: {
        scheduled_closing_date: {
            get() {
                return store.state.scheduled_closing_date;
            },
            set(val) {
                store.state.scheduled_closing_date = val;
            },
        },
    },
}
</script>
